<template>
    <div class="credit-info">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <b-row align-v="center" class="py-3">
                    <b-col cols="6">
                        <p class="text-muted">Hub Approval</p>
                        <h4 class="listing-title d-inline-block mb-0">Commission Payout Summary Details</h4>
                    </b-col>
                    <b-col cols="6" class="text-right ">
                        <base-button type="primary" icon size="sm" @click="close()">
                            <span class="btn-inner--text">Back / Close</span>
                        </base-button>
                        <!-- <b-button variant="primary" class="btn-header" @click="modals.show_new_customer = true">Create New</b-button> -->
                    </b-col>
                </b-row>
            </b-card-header>
            <b-table-simple responsive table-variant="white">
                <b-thead head-variant="light">
                    <b-tr>
                        <b-th>Setting Title</b-th>
                        <b-th>Setting Value</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td>Comms Payout Summary ID</b-td>
                        <b-td><b-button variant="light" @click.prevent="openView(tableData)">
                            # <span class="name text-primary">{{ tableData.comms_payout_summary_id }}</span>
                        </b-button></b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Case ID</b-td>
                        <b-td>{{ tableData.case_id }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Case Recognize ID</b-td>
                        <b-td v-if="tableData.case_recognize">{{ tableData.case_recognize.case_recognize_id }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Nett Price (RM)</b-td>
                        <b-td>{{ tableData.cps_develop_nett_price | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">Service Type Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_service_type_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">Total Revenue Point Obtained (RM)</b-td>
                        <b-td>{{ tableData.cps_total_revenue_point | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">Pool Allocation Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_pool_allocation_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">Pool Revenue Point (RM)</b-td>
                        <b-td>{{ tableData.cps_pool_revenue_point | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">Direct Payout Allocation Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_direct_payout_allocation_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">Direct Payout Revenue Point (RM)</b-td>
                        <b-td>{{ tableData.cps_balance_revenue_point | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">T1 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_T1_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">T2 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_T2_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">T3 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_T3_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">T4 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_T4_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">T5 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_T5_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">R1 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_R1_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">R2 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_R2_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">R3 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_R3_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">P1 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_P1_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">P2 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_P2_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td scope="row">P3 Setting Percentage (%)</b-td>
                        <b-td>{{ tableData.cps_P3_setting_percentage | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
        <!--Direct Payout Detail modal-->
        <PayoutDetailsModal 
            :showDirectPayoutDetails.sync="modals.showDirectPayoutDetails" 
            :currentCommsPayoutSummary="current_view"
            @close-modal="modals.showDirectPayoutDetails=false"
            :decide_mode="decide_mode"
            :permission="permission"
        />
    </div>
</template>
<script>
import { Card, Button } from 'element-ui'
import { axios, services, getHeader,debounce } from '@/assets/js/httpImports.js'
import PayoutDetailsModal from "@/views/Commission/Hub/HubProfile/CenterProfileDetails/PayoutDetailsModal";
import { useAuthStore } from '@/stores/authStore'
import { mapState, mapActions } from 'pinia'
import { MANAGER_ROLE_IDS } from '@/assets/js/roles.js' 

export default {
    components: {
        [Card.name]: Card,
        [Button.name]: Button,
        PayoutDetailsModal,
    },
    data() {
        return {
            MANAGER_ROLE_IDS: MANAGER_ROLE_IDS,
            tableData: [],
            modals:{
                showDirectPayoutDetails: false,
            },
            current_view: [],
            decide_mode: false,
            permission: {
                acceptor: false,
                reviewer: false,
                approver: false,
                admin: false,
            }
        }
    },
    computed: {
        ...mapState(useAuthStore,['auth_user']),
    },
    created() {
        this.getCommsPayoutDetails();
    },
    methods: {
        close() {
            this.$router.back();
        },
        openView(row) {
            this.modals.showDirectPayoutDetails = true;
            this.current_view = row;
            this.getPermissionSetting();
            // overwrite all button
            // this.decide_mode = false;
        },
        getPermissionSetting() {
            const hub_pending_approval = this.current_view.hub_pending_approval;
            if(hub_pending_approval.is_accepted == null || hub_pending_approval.is_reviewed == null || hub_pending_approval.is_approved == null)
            {
                this.decide_mode = true;
                this.checkIsAdmin();
                if(!this.permission.admin)
                {
                    this.checkIsAcceptor();
                    this.checkIsReviewer();
                    this.checkIsApprover();
                }
            }
            else if(hub_pending_approval.is_accepted == 0 || hub_pending_approval.is_reviewed == 0 || hub_pending_approval.is_approved == 0)
            {
                this.decide_mode = false;
            }
        },
        checkIsAcceptor() {
            if(this.auth_user.id == this.current_view.hub.hub_manager.id)
            {
                this.permission.acceptor = true;
            }
            else
            {
                this.permission.acceptor = false;
            }
        },
        checkIsReviewer() {
            axios.get(services.hub + 'hub_comms/hub_pending_approval.check_is_reviewer/COMMS_PAYOUT_SUMMARY', { headers: getHeader() })
            .then(res => {
                if(res.data == 1)
                {
                    this.permission.reviewer = true;
                }
                else
                {
                    this.permission.reviewer = false;
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Checking is reviewer function failed: " + error.response.data.message) 
            });
        },
        checkIsApprover() {
            axios.get(services.hub + 'hub_comms/hub_pending_approval.check_is_approver/COMMS_PAYOUT_SUMMARY', { headers: getHeader() })
            .then(res => {
                if(res.data == 1)
                {
                    this.permission.approver = true;
                }
                else
                {
                    this.permission.approver = false;
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Checking is approver function failed: " + error.response.data.message) 
            });
        },
        checkIsAdmin() {
            if(_gHlp.checkRoleType( ['admin', 'corporate']))
            {
                this.permission.admin = true;
            }
            else
            {
                this.permission.admin = false;
            }
        },
        getCommsPayoutDetails() {
            axios.get(services.hub + 'hub_comms/comms_payout_summary/' + this.$route.params.comms_payout_summary_id, { headers: getHeader() })
            .then(res => {
                this.tableData = res.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing Commission Payout Summary failed: " + error.response.data.message) 
            });
        },
    },

}
</script>